import mappy from '../assets/mappy.svg'
import snake from '../assets/snake.svg'
import backendSample from '../assets/backend-sample.svg'

export const portfolioData = [
    {
        id: 1,
        image: mappy,
        title : 'Mappy — Crop Atlas',
        tech : 'React · Vite · Leaflet · Open Data',
        period : 'Feb 2026 – Present',
        github : '',
        demo : 'https://mappy-krishimap.netlify.app/',
        description : 'Click any Indian district to instantly see specialty crops, soil profile (pH, texture, organic carbon), live weather, and the nearest Krishi Vigyan Kendra. Built solo on React + Leaflet with live data from SoilGrids 2.0, Open-Meteo and Wikipedia REST. Zero API keys, no backend — fully open data.'
    },
    {
        id: 2,
        image: snake,
        title : 'Snake World',
        tech : 'HTML · CSS · JavaScript',
        period : 'Jan 2026 – Present',
        github : '',
        demo : 'https://game-v1-snake.netlify.app/',
        description : 'A pure HTML snake game — lightweight, fast and live in the browser. Built for testing and fun.'
    },
    {
        id: 3,
        image: backendSample,
        title : 'Backend Dev — Sample',
        tech : 'Node.js · Express · MongoDB · Docker',
        period : 'Sample',
        github : '',
        demo : '',
        description : 'Representative sample of production backend work: REST APIs, microservices, payment & aggregator integrations (Stripe, Razorpay, Uber Eats, DoorDash), Redis caching, Socket.io events and Dockerised deployments. Full source lives in private company repos.'
    }
]
